module.exports = __webpack_public_path__ + "media/images/icons/lang-d4ea9cdf265a6634acc806ae848a3958.svg";